import { z } from "zod";
import { PlatformModules } from "@miplatform/types";

export const configDepartmentSchema = z.object({
  name: z.string().min(1, "Department name is required"),
  description: z.string().min(1, "Description is required"),
  abbreviation: z
    .string()
    .min(1, "Abbreviation is required")
    .max(5, "Abbreviation must be at most 5 characters"),
  modules: z.array(z.nativeEnum(PlatformModules)).optional(),
});
